import React from 'react';
import {
  Box,
  Button,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export default function SidebarDocs() {
  const bg = useColorModeValue(
    'linear-gradient(145deg, rgba(111, 66, 193, 0.14), rgba(13, 202, 240, 0.16))',
    'linear-gradient(145deg, rgba(111, 66, 193, 0.22), rgba(23, 162, 184, 0.14))',
  );
  const borderColor = useColorModeValue(
    'rgba(162, 176, 210, 0.20)',
    'rgba(255,255,255,0.08)',
  );

  return (
    <Box
      borderRadius="26px"
      p="20px"
      bg={bg}
      border="1px solid"
      borderColor={borderColor}
    >
      <Text
        textTransform="uppercase"
        letterSpacing="0.16em"
        fontSize="xs"
        fontWeight="800"
        color="brand.500"
        mb="8px"
      >
        Workflow Tip
      </Text>
      <Heading size="sm" mb="8px">
        Keep inspections organized
      </Heading>
      <Text color="secondaryGray.700" fontSize="sm" lineHeight="1.7" mb="16px">
        Use month folders for review cycles, then open the inspection list for
        detailed filtering and edits.
      </Text>
      <Button
        as={RouterLink}
        to="/admin/inspections/create"
        variant="brand"
        w="100%"
      >
        New Inspection
      </Button>
    </Box>
  );
}
